import { render } from "./Modal.vue?vue&type=template&id=3ec4c56b&scoped=true&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import "./Modal.vue?vue&type=style&index=0&id=3ec4c56b&scoped=true&lang=scss"
import "./Modal.vue?vue&type=style&index=1&id=3ec4c56b&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ec4c56b"]])

export default __exports__